﻿/* redesign.js — interactions for the "The Network" theme.
   Loaded ONLY when ViewData["Redesign"]=true. All lookups are guarded. */
(function () {
    const reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;

    /* light / dark theme toggle (bulb, top-right) */
    const themeBtn = document.getElementById('rd-theme');
    if (themeBtn) {
        const root = document.documentElement;
        const sync = () => themeBtn.setAttribute('aria-pressed', root.getAttribute('data-theme') === 'light' ? 'true' : 'false');
        sync();
        themeBtn.addEventListener('click', () => {
            const toLight = root.getAttribute('data-theme') !== 'light';
            if (toLight) root.setAttribute('data-theme', 'light'); else root.removeAttribute('data-theme');
            try { localStorage.setItem('ls-theme', toLight ? 'light' : 'dark'); } catch (e) { }
            sync();
            document.dispatchEvent(new CustomEvent('rd-theme-change'));
        });
    }

    /* custom cursor + magnetic buttons */
    const cur = document.getElementById('rd-cur'), curd = document.getElementById('rd-curd');
    if (cur && curd && matchMedia('(hover:hover)').matches) {
        let mx = innerWidth / 2, my = innerHeight / 2, cx = mx, cy = my;
        addEventListener('mousemove', e => { mx = e.clientX; my = e.clientY; curd.style.transform = `translate(${mx}px,${my}px) translate(-50%,-50%)`; });
        (function loop() { cx += (mx - cx) * .18; cy += (my - cy) * .18; cur.style.transform = `translate(${cx}px,${cy}px) translate(-50%,-50%)`; requestAnimationFrame(loop); })();
        document.querySelectorAll('a,button,.mag,input,select,textarea,.go-link').forEach(el => {
            el.addEventListener('mouseenter', () => cur.classList.add('big'));
            el.addEventListener('mouseleave', () => cur.classList.remove('big'));
        });
        document.querySelectorAll('.mag').forEach(b => {
            b.addEventListener('mousemove', e => { const r = b.getBoundingClientRect(); const x = e.clientX - r.left - r.width / 2, y = e.clientY - r.top - r.height / 2; b.style.transform = `translate(${x * .3}px,${y * .4}px)`; });
            b.addEventListener('mouseleave', () => b.style.transform = '');
        });
    }

    /* scroll progress + header solid state */
    const prog = document.getElementById('rd-prog'), hdr = document.getElementById('rd-hdr');
    if (prog || hdr) {
        addEventListener('scroll', () => {
            const h = document.documentElement;
            if (prog) prog.style.width = (h.scrollTop / (h.scrollHeight - h.clientHeight) * 100) + '%';
            if (hdr) hdr.classList.toggle('solid', h.scrollTop > 60);
        });
    }

    /* mobile overlay menu */
    const burger = document.getElementById('rd-burger'), overlay = document.getElementById('rd-overlay');
    if (burger) {
        const setMenu = open => { document.body.classList.toggle('menu-open', open); burger.setAttribute('aria-expanded', open); document.body.style.overflow = open ? 'hidden' : ''; };
        burger.addEventListener('click', () => setMenu(!document.body.classList.contains('menu-open')));
        if (overlay) overlay.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setMenu(false)));
        addEventListener('keydown', e => { if (e.key === 'Escape') setMenu(false); });
    }

    /* hero entrance */
    const hero = document.getElementById('hero');
    if (hero) requestAnimationFrame(() => hero.classList.add('go'));

    /* network canvas (theme-aware) */
    const cv = document.getElementById('rd-net');
    if (cv) {
        const host = cv.parentElement;
        const ctx = cv.getContext('2d');
        let W, H, DPR, nodes = [], pointer = { x: -9999, y: -9999 };
        let lineRGB = '79,180,255', nodeFill = 'rgba(155,200,255,.7)', nodeNear = '#9cd2ff';
        const themeColors = () => {
            const light = document.documentElement.getAttribute('data-theme') === 'light';
            lineRGB = light ? '30,90,200' : '79,180,255';
            nodeFill = light ? 'rgba(28,78,165,.5)' : 'rgba(155,200,255,.7)';
            nodeNear = light ? '#1f5fd0' : '#9cd2ff';
        };
        themeColors();
        const size = () => { DPR = Math.min(devicePixelRatio || 1, 2); W = cv.width = innerWidth * DPR; H = cv.height = cv.offsetHeight * DPR; };
        const build = () => { const count = Math.min(80, Math.floor(innerWidth / 18)); nodes = []; for (let i = 0; i < count; i++) nodes.push({ x: Math.random() * W, y: Math.random() * H, vx: (Math.random() - .5) * .25 * DPR, vy: (Math.random() - .5) * .25 * DPR }); };
        size(); build();
        addEventListener('resize', () => { size(); build(); });
        host.addEventListener('mousemove', e => { const r = cv.getBoundingClientRect(); pointer.x = (e.clientX - r.left) * DPR; pointer.y = (e.clientY - r.top) * DPR; });
        host.addEventListener('mouseleave', () => { pointer.x = pointer.y = -9999; });
        const LINK = 140 * DPR, PULL = 170 * DPR;
        const frame = () => {
            ctx.clearRect(0, 0, W, H);
            for (const n of nodes) {
                n.x += n.vx; n.y += n.vy;
                if (n.x < 0 || n.x > W) n.vx *= -1;
                if (n.y < 0 || n.y > H) n.vy *= -1;
                const dx = n.x - pointer.x, dy = n.y - pointer.y, d = Math.hypot(dx, dy);
                if (d < PULL && d > 0) { const f = (PULL - d) / PULL * 1.6 * DPR; n.x += dx / d * f; n.y += dy / d * f; }
            }
            for (let i = 0; i < nodes.length; i++) for (let j = i + 1; j < nodes.length; j++) {
                const a = nodes[i], b = nodes[j], dx = a.x - b.x, dy = a.y - b.y, d = Math.hypot(dx, dy);
                if (d < LINK) { const o = (1 - d / LINK) * .5; ctx.strokeStyle = `rgba(${lineRGB},${o})`; ctx.lineWidth = DPR * .7; ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke(); }
            }
            for (const n of nodes) {
                const dp = Math.hypot(n.x - pointer.x, n.y - pointer.y), near = dp < PULL;
                ctx.beginPath(); ctx.arc(n.x, n.y, (near ? 2.4 : 1.7) * DPR, 0, 7);
                ctx.fillStyle = near ? nodeNear : nodeFill; ctx.fill();
            }
            if (!reduce) requestAnimationFrame(frame);
        };
        frame();
        document.addEventListener('rd-theme-change', () => { themeColors(); if (reduce) frame(); });
    }

    /* manifesto word reveal — wrap each word individually, even inside <em>, so text flows naturally */
    document.querySelectorAll('[data-split]').forEach(p => {
        const wrap = node => {
            [...node.childNodes].forEach(n => {
                if (n.nodeType === 3) {
                    const frag = document.createDocumentFragment();
                    n.textContent.split(/(\s+)/).forEach(t => {
                        if (!t) return;
                        if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(t)); }
                        else { const s = document.createElement('span'); s.className = 'w'; s.textContent = t; frag.appendChild(s); }
                    });
                    n.replaceWith(frag);
                } else if (n.nodeType === 1) {
                    wrap(n);
                }
            });
        };
        wrap(p);
    });
    const splits = document.querySelectorAll('[data-split]');
    if (splits.length) {
        const wio = new IntersectionObserver(es => es.forEach(e => {
            if (e.isIntersecting) { const ws = [...e.target.querySelectorAll('.w')]; ws.forEach((w, i) => setTimeout(() => w.classList.add('lit'), i * 55)); wio.unobserve(e.target); }
        }), { threshold: .25 });
        splits.forEach(p => wio.observe(p));
    }

    /* horizontal product pan */
    const horizon = document.querySelector('.horizon'), track = document.querySelector('.track');
    if (horizon && track) {
        let dist = 0;
        const setup = () => {
            const st = horizon.querySelector('.horizon-sticky');
            if (innerWidth < 880 || reduce) {
                horizon.style.height = 'auto';
                if (st) st.style.cssText = 'position:static;height:auto;display:block;overflow:visible';
                track.style.cssText = 'display:flex;flex-direction:column;gap:24px;padding:0 22px';
                horizon.querySelectorAll('.panel').forEach(pl => { pl.style.cssText = 'flex:none;width:100%;height:auto;min-height:60vh;margin:0'; });
                track.style.transform = '';
                dist = 0;
                return;
            }
            if (st) st.style.cssText = '';
            track.style.cssText = '';
            horizon.querySelectorAll('.panel').forEach(pl => { pl.style.cssText = ''; });
            dist = Math.max(0, track.scrollWidth - innerWidth + innerWidth * 0.04);
            horizon.style.height = (innerHeight + dist) + 'px';
        };
        const pan = () => {
            if (dist <= 0) { track.style.transform = ''; return; }
            const total = horizon.offsetHeight - innerHeight;
            const p = total > 0 ? Math.min(1, Math.max(0, -horizon.getBoundingClientRect().top / total)) : 0;
            track.style.transform = `translateX(${-p * dist}px)`;
        };
        addEventListener('scroll', pan, { passive: true });
        addEventListener('resize', () => { setup(); pan(); });
        setup(); pan();
    }

    /* client marquee duplicate */
    const mrq = document.getElementById('rd-mrq');
    if (mrq && mrq.children.length) mrq.innerHTML += mrq.innerHTML;

    /* ---- product detail page ---- */
    /* hero clip-wipe reveal */
    const pdHero = document.querySelector('.pd-hero');
    if (pdHero) requestAnimationFrame(() => pdHero.classList.add('go'));

    /* generic scroll reveal (page motion signature) */
    const reveals = document.querySelectorAll('[data-reveal]');
    if (reveals.length) {
        if (reduce || !('IntersectionObserver' in window)) {
            reveals.forEach(el => el.classList.add('in'));
        } else {
            const rio = new IntersectionObserver(es => es.forEach(e => {
                if (e.isIntersecting) { e.target.classList.add('in'); rio.unobserve(e.target); }
            }), { threshold: .15, rootMargin: '0px 0px -8% 0px' });
            reveals.forEach(el => rio.observe(el));
        }
    }

    /* feature card pointer glow */
    document.querySelectorAll('.pd-feat').forEach(c => {
        c.addEventListener('mousemove', e => { const r = c.getBoundingClientRect(); c.style.setProperty('--mx', (e.clientX - r.left) + 'px'); c.style.setProperty('--my', (e.clientY - r.top) + 'px'); });
    });

    /* scroll-driven border light on the consult card (forward on scroll down, reverse on scroll up) */
    const pdCards = document.querySelectorAll('.pd-card');
    if (pdCards.length && !reduce) {
        const updCards = () => { const a = scrollY * 0.22; pdCards.forEach(c => c.style.setProperty('--pd-a', a + 'deg')); };
        addEventListener('scroll', updCards, { passive: true });
        updCards();
    }

    /* feature detail modal */
    const pdModal = document.getElementById('pd-modal');
    if (pdModal) {
        const mBody = pdModal.querySelector('.pd-modal-body'), mTitle = pdModal.querySelector('h3');
        const openM = card => { mTitle.textContent = card.getAttribute('data-title') || ''; const tpl = card.querySelector('.pd-feat-full'); mBody.innerHTML = tpl ? tpl.innerHTML : ''; pdModal.classList.add('open'); document.body.style.overflow = 'hidden'; };
        const closeM = () => { pdModal.classList.remove('open'); document.body.style.overflow = ''; };
        document.querySelectorAll('.pd-feat').forEach(c => {
            c.addEventListener('click', () => openM(c));
            c.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openM(c); } });
        });
        /* the capability orbit's "Read more" is a real button, so a click covers the keyboard too */
        document.querySelectorAll('.pd-orb-more').forEach(b => b.addEventListener('click', () => openM(b.closest('.pd-orb-panel'))));
        pdModal.querySelector('.pd-modal-close').addEventListener('click', closeM);
        pdModal.querySelector('.pd-modal-bg').addEventListener('click', closeM);
        addEventListener('keydown', e => { if (e.key === 'Escape') closeM(); });
    }

    /* blog post TOC scrollspy */
    const toc = document.querySelector('.bl-toc');
    if (toc && 'IntersectionObserver' in window) {
        const links = [...toc.querySelectorAll('a[href^="#"]')];
        const map = links.map(a => ({ a, sec: document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1))) })).filter(o => o.sec);
        if (map.length) {
            const spy = new IntersectionObserver(es => es.forEach(e => {
                if (e.isIntersecting) { links.forEach(l => l.classList.remove('active')); const hit = map.find(o => o.sec === e.target); if (hit) hit.a.classList.add('active'); }
            }), { rootMargin: '-20% 0px -70% 0px' });
            map.forEach(o => spy.observe(o.sec));
        }
    }

    /* solution page section explorer — the headings are the navigation and the
       body swaps to whichever one is picked. Panels stay in the DOM so anchors
       and crawlers still reach them; only display is toggled. */
    document.querySelectorAll('[data-explore]').forEach(root => {
        const tabs = [...root.querySelectorAll('.pd-explore-tab')];
        const panels = [...root.querySelectorAll('.pd-explore-panel')];
        if (!tabs.length || tabs.length !== panels.length) return;

        const show = (i, focus) => {
            tabs.forEach((t, n) => {
                const on = n === i;
                t.classList.toggle('is-on', on);
                t.setAttribute('aria-selected', on ? 'true' : 'false');
                t.tabIndex = on ? 0 : -1;
            });
            panels.forEach((pn, n) => pn.classList.toggle('is-on', n === i));
            if (focus) tabs[i].focus();
        };

        tabs.forEach((t, i) => {
            t.addEventListener('click', () => {
                show(i);
                /* stacked layout puts the panel below the list, so bring it up;
                   offset clears the sticky header */
                if (innerWidth <= 980) {
                    const y = panels[i].getBoundingClientRect().top + scrollY - 96;
                    scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
                }
            });
            t.addEventListener('keydown', e => {
                const last = tabs.length - 1;
                let n = null;
                if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = i === last ? 0 : i + 1;
                else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = i === 0 ? last : i - 1;
                else if (e.key === 'Home') n = 0;
                else if (e.key === 'End') n = last;
                if (n === null) return;
                e.preventDefault();
                show(n, true);
            });
        });

        /* a link to #anchor must open that panel rather than land on a hidden one */
        const fromHash = () => {
            const id = decodeURIComponent(location.hash.slice(1));
            if (!id) return;
            const i = panels.findIndex(pn => pn.id === id);
            if (i > -1) show(i);
        };
        fromHash();
        addEventListener('hashchange', fromHash);
    });

    /* product page capability orbit — the icons round the ring are tabs and the
       picked one's summary sits in the middle. While it is on screen it steps on
       by itself: a progress ring on the picked icon is a CSS animation, and its
       end moves to the next one, so hovering or focusing the orbit (which pauses
       the animation) pauses the stepping too. Picking one stops it for good. */
    document.querySelectorAll('[data-orbit]').forEach(root => {
        const tabs = [...root.querySelectorAll('.pd-orb-btn')];
        const panels = [...root.querySelectorAll('.pd-orb-panel')];
        if (!tabs.length || tabs.length !== panels.length) return;

        let cur = 0;
        const show = (i, focus) => {
            cur = i;
            tabs.forEach((t, n) => {
                const on = n === i;
                t.classList.toggle('is-on', on);
                t.setAttribute('aria-selected', on ? 'true' : 'false');
                t.tabIndex = on ? 0 : -1;
            });
            panels.forEach((pn, n) => pn.classList.toggle('is-on', n === i));
            if (focus) tabs[i].focus();
        };
        const stop = () => root.classList.remove('is-auto');

        tabs.forEach((t, i) => {
            t.addEventListener('click', () => { stop(); show(i); });
            t.addEventListener('keydown', e => {
                const last = tabs.length - 1;
                let n = null;
                if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = i === last ? 0 : i + 1;
                else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = i === 0 ? last : i - 1;
                else if (e.key === 'Home') n = 0;
                else if (e.key === 'End') n = last;
                if (n === null) return;
                e.preventDefault();
                stop();
                show(n, true);
            });
            t.addEventListener('animationend', e => {
                if (e.animationName === 'pd-orb-turn' && root.classList.contains('is-auto')) show((cur + 1) % tabs.length);
            });
        });

        if (!reduce && 'IntersectionObserver' in window) {
            root.classList.add('is-auto', 'is-away');
            new IntersectionObserver(es => es.forEach(e => root.classList.toggle('is-away', !e.isIntersecting)), { threshold: .35 }).observe(root);
        }
    });
})();